'use client';
export { Icon } from '@chakra-ui/react';

//# sourceMappingURL=index.js.map